import { createTheme } from "@mui/material";
import { TRUE } from "sass";

const themePrimary = {
    main: '#336699',
    light: '#DDE1FF',
    dark: '#223DA2',
    contrastText: '#fff',
}

const themeSecondary = {
    main: '#D7B24D',
    light: '#FFF8E3',
    dark: '#9E7401',
    contrastText: '#fff',
}

export const theme = createTheme({
    palette: {
        primary: themePrimary,
        secondary: themeSecondary
    },
})

export const primaryButtonStyle: any = {
    "variant": "contained",
    "disableElevation": true,
    "size": "large",
    "fullWidth": true
}

export const primaryTextField: any = {
    "variant": "standard",
    "fullWidth": true
}